module.exports = __webpack_public_path__ + "img/back2.9ccd2ca3.png";